/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";
import perform from "mutation/perform";
import {
    NoteOriginalImageExtractorMutation$data,
    NoteOriginalImageExtractorMutation$variables
} from "mutation/__generated__/NoteOriginalImageExtractorMutation.graphql";

const mutation = graphql`
    mutation NoteOriginalImageExtractorMutation($input: MusicNoteOriginalImageExtractorInput!) {
        music_note_original_image_extractor(input: $input) {
            job_id
        }
    }
`;

export default async function NoteOriginalImageExtractor(pieceId: string, sheetId: string, noteId: string, bulbId: string): Promise<string> {
    const variables: NoteOriginalImageExtractorMutation$variables = {
        input: {
            sheet_id: sheetId,
            piece_id: pieceId,
            note_id: noteId,
            bulb_id: bulbId
        }
    };
    const output = await perform<NoteOriginalImageExtractorMutation$data>(mutation, variables);
    return output.music_note_original_image_extractor.job_id;
}